<template lang="pug">
  nt-dialog(
    v-model='dialog' 
    :title="$t('title.dialog-payment-noti')"
  ) 
    v-card-text
      v-card(flat color='#f9f9f9')
        v-row.mx-3.mt-5
          v-col {{ $t('total-payment') }}
          v-col(align="end")
            b {{ amount }} {{ $t('unit.baht') }} 
      v-card.my-3(outlined)
        v-row
          v-col.text-center
            v-icon(
              x-large 
              @click='changHour(true)'
            ) mdi-menu-up
            h2 {{ hours }}
            v-icon(
              x-large 
              @click='changHour(false)'
            ) mdi-menu-down
          v-col.text-center
            v-icon(x-large) mdi-minus
            h2 :
            v-icon(x-large) mdi-minus
          v-col.text-center
            v-icon(
              x-large 
              @click='changMinute(true)'
            ) mdi-menu-up
            h2 {{ minute }}
            v-icon(
              x-large 
              @click='changMinute(false)'
            ) mdi-menu-down 
      //- v-text-field.mt-5(
      //-   v-model='form.request_description'
      //-   :placeholder="$t('placeholder.note')"
      //-   dense 
      //-   outlined
      //- )
    v-card-actions
      v-spacer
      v-btn(
        color='grey-light-7'
        depressed
        @click='cancel()'
      )  ยกเลิก
      v-btn(
        color='var(--bg-secondary-color)'
        depressed
        dark
        :loading='submitStatus'
        :disabled='submitStatus'
        @click='submit ()'
      ) ยืนยัน

</template>
<script>   
import { credits as apiCredits } from '@/apis'  

export default {  
  data: () => ({
    dialog:false,
    form: {
      request_description : null,
    }, 
    amount:null,
    hours:null,
    minute : null,
    rangeHours:[],
    rangeMinute:[], 
    submitStatus : false
  }),
  methods : { 
    changHour (bool) {
      let value = bool?  1 : -1
      let result = parseInt(this.hours) + value  
      result = result < this.rangeHours[0]  
      ? this.rangeHours[0] 
      : result > this.rangeHours[1] ? this.rangeHours[1] 
      : result 
      result = this.convertHour(result)  
      this.hours = this.convertDigit(result) 
    }, 

    changMinute (bool) {
      let value = bool?  1 : -1
      let result = parseInt(this.minute) + value 
      result = result < this.rangeMinute[0]  
      ? this.rangeMinute[0] 
      : result > this.rangeMinute[1] ? this.rangeMinute[1] 
      : result 
      result = this.convertMinute(result)  
      this.minute = this.convertDigit(result) 
    },
    
    cancel () {
      this.dialog = false
      this.$ga.event('Button', 'CancelDialogInform', 'DepositPage','' )
    },

    convertDigit (result) {
      return result < 10 ? '0' + result : result.toString()
    },

    convertMinute (value) {
      return value<0 ? 60 + value  : value >= 60 ? value - 60 : value
    },

    convertHour (value) {
      return value<0 ? 24 + value  : value >= 24 ? value - 24 : value
    }, 

    openDialog (amount, uuid) { 
      this.uuid = uuid
      this.amount = amount
      this.dialog = true
      let today = new Date();  
      let minute = today.getMinutes() 
      let hours = today.getHours() 
      this.hours = this.convertDigit(hours)
      this.minute = this.convertDigit(minute)
      this.rangeHours[0] =  minute + 5 > 60 ? this.convertHour(hours - 1) : hours 
      this.rangeHours[1] = minute - 5 < 0 ? this.convertHour(hours + 1) : hours
      this.rangeMinute[1] = this.convertMinute(minute + 5)
      this.rangeMinute[0] = this.convertMinute(minute - 5) 
    },
    async submit () { 
      this.submitStatus = true
      this.$ga.event('Button', 'Deposit', 'DepositPage','' )
      let today = new Date(); 
      let year = today.getFullYear()
      let month = ("0" + (today.getMonth()+1)).slice(-2) 
      let date = ("0" + today.getDate()).slice(-2)  
      let confirmat = `${year}-${month}-${date} ${this.hours}:${this.minute}`  

      this.form.request_confirmed_at = confirmat 

      const [err,] = await apiCredits.confirm(this.uuid,this.form)

      if(err) {
        this.$alert('',err,'warning') 
        return
      } 
       
      this.dialog = false
      this.submitStatus =false 
      this.$emit('next')  
    }
  }
}
</script> 